import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { POST_GROUP_AMENDMENT_CHECK_ELIGIBILITY_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

interface CheckEligibilityRequest {
  examType: string;
}

interface CheckEligibilityResponse {
  eligible: boolean;
  error: {
    code: string;
    message: string;
  };
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: CheckEligibilityResponse) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  onSettled?: () => void;
}

export const usePostGroupAmendmentCheckEligibility = ({ onSuccess, onError, onSettled }: Input) => {
  const postGroupAmendmentCheckEligibility = async (payload: CheckEligibilityRequest) => {
    const res = await axiosClient.post<CheckEligibilityResponse>(
      POST_GROUP_AMENDMENT_CHECK_ELIGIBILITY_URL,
      payload
    );
    return res.data;
  };

  return useCustomMutation(
    postGroupAmendmentCheckEligibility,
    {
      onSuccess,
      onError,
      onSettled,
    },
    false,
    false
  );
};
